module.exports = __webpack_public_path__ + "img/TechFishingBoat3_ua.085d655f.webp";